import {get} from "lodash"
import {Branding} from "types/branding"
import BaseService from "./Base"

class BrandingsService extends BaseService {
    async getBrandings(data: Branding.GetBrandingParams = {}): Promise<Branding.BrandingDomainGroup[]> {
        const response = await this.post("/v1/settings/brandings/list", data)
        return get(response, "data.data", [])
    }

    async updateBrandings(data: FormData): Promise<Branding.BrandingDomainGroup[]> {
        const response = await this.post("/v1/settings/brandings/update", data)
        return get(response, "data.data", [])
    }

    async deleteBrandings(data: Branding.DeleteBrandingsParams): Promise<boolean> {
        const response = await this.post("/v1/settings/brandings/delete", data)
        return get(response, "data.data", false)
    }

    async setPrimaryBrandings(data: Branding.SetPrimaryBrandingsParams): Promise<Branding.BrandingDomainGroup[]> {
        const response = await this.post("/v1/settings/brandings/set-primary", data)
        return get(response, "data.data", [])
    }

    async createSubdomain(data: Branding.CreateSubdomainParams): Promise<Branding.BrandingDomainGroup[]> {
        const response = await this.post("/v1/settings/brandings/create-subdomain", data)
        return get(response, "data.data", [])
    }

    async deleteSubdomain(data: Branding.DeleteSubdomainParams): Promise<Branding.BrandingDomainGroup[]> {
        const response = await this.post("/v1/settings/brandings/delete-subdomain", data)
        return get(response, "data.data", [])
    }
}

export default BrandingsService
